import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import {Box, Button, IconButton, Typography} from '@mui/material';
import Container from '@mui/material/Container';
import {useLoadScript} from '@react-google-maps/api';
import axiosRetry from 'axios-retry';
import * as React from 'react';
import {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {getGeocode, getLatLng} from 'use-places-autocomplete';
import axios from '../../axios';
import EstablishmentCommunity from './EstablishmentCommunity';
import EstablishmentContact from './EstablishmentContact';
import EstablishmentHeader from './EstablishmentHeader';
import EstablishmentInformation from './EstablishmentInformation';

const libraries = ['places'];

const Establishment = ({token}) => {
  const [establishment, setEstablishment] = useState({});
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');
  const navigate = useNavigate();
  const {id} = useParams();
  const [markers, setMarkers] = useState([]);
  const [anchor, setAnchor] = useState(1);
  const [showMoveUpButton, setShowMoveUpButton] = useState(false);
  const [showMoveDownButton, setShowMoveDownButton] = useState(true);
  axiosRetry(axios, {retries: 3});

  const populateMarkers = institution => {
    getGeocode({
      address:
        institution.road.text +
        ' ' +
        institution.zipcode.text +
        ' ' +
        institution.city.text,
    })
      .then(results => getLatLng(results[0]))
      .then(({lat, lng}) => {
        setLatitude(lat);
        setLongitude(lng);
        setMarkers(current => [
          ...current,
          {position: {lat, lng}, name: institution.name.text},
        ]);
      })
      .catch(error => {
        console.log('Error: ', error);
      });
  };

  useEffect(() => {
    if (Object.keys(establishment).length !== 0 && establishment.length !== 0) {
      populateMarkers(establishment);
    }
    return setMarkers([]);
  }, [establishment]);

  useEffect(() => {
    axios
      .get(`${axios.defaults.apiURL}/institution/${id}`)
      .then(function (response) {
        console.log('-----', response.data[0]);
        setEstablishment(response.data[0]);
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 401) {
            localStorage.clear();
            navigate('/login');
          }
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        }
      });

    return () => {
      setEstablishment({});
    };
  }, []);

  const {isLoaded, loadError} = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
  });

  const moveUp = () => {
    const tempPosition = anchor - 1;
    const tempAnchor = 'anchor' + tempPosition;
    const anchorEl = document.getElementById(tempAnchor);
    if (anchorEl) {
      window.scrollTo({
        top: anchorEl.offsetTop - 200,
        behavior: 'smooth',
      });
      setAnchor(anchor - 1);
    }
    const nextPosition = tempPosition - 1;
    if (document.getElementById('anchor' + nextPosition) == null) {
      setShowMoveUpButton(false);
    } else {
      setShowMoveUpButton(true);
      setShowMoveDownButton(true);
    }
  };

  const moveDown = () => {
    const tempPosition = anchor + 1;
    const tempAnchor = 'anchor' + tempPosition;
    const anchorEl = document.getElementById(tempAnchor);
    if (anchorEl) {
      window.scrollTo({
        top: anchorEl.offsetTop - 200,
        behavior: 'smooth',
      });
      setAnchor(anchor + 1);
    }
    const nextPosition = tempPosition + 1;
    if (document.getElementById('anchor' + nextPosition) == null) {
      setShowMoveDownButton(false);
    } else {
      setShowMoveDownButton(true);
      setShowMoveUpButton(true);
    }
  };

  const moveTo = idAnchor => {
    const tempPosition = idAnchor;
    const tempAnchor = 'anchor' + tempPosition;
    const anchorEl = document.getElementById(tempAnchor);
    if (anchorEl) {
      window.scrollTo({
        top: anchorEl.offsetTop - 200,
        behavior: 'smooth',
      });
      setAnchor(idAnchor);
    }
    const nextPosition = tempPosition + 1;
    if (document.getElementById('anchor' + nextPosition) == null) {
      setShowMoveDownButton(false);
      setShowMoveUpButton(true);
    } else {
      setShowMoveDownButton(true);
      setShowMoveUpButton(true);
    }
  };

  return Object.keys(establishment).length === 0 ? (
    <div></div>
  ) : (
    <Box >
      <EstablishmentHeader
        establishment={establishment}
        latitude={latitude}
        longitude={longitude}></EstablishmentHeader>
      <br />
      <Container className={'container'}>
        <Typography
            component={'div'}
            id={'establishmentNav'}
            variant={'subtitle1'}>
          <Button className="buttonEstablishmentNav" onClick={() => moveTo(1)}>
            <Typography variant={'subtitle3'}>Informations</Typography>
          </Button>
          <Button className="buttonEstablishmentNav" onClick={() => moveTo(4)}>
            <Typography variant={'subtitle3'}>Communautés</Typography>
          </Button>
          <Button className="buttonEstablishmentNav" onClick={() => moveTo(5)}>
            <Typography variant={'subtitle3'}>Contact</Typography>
          </Button>
        </Typography>
        <br />
      </Container>

      <EstablishmentInformation
        establishment={establishment}
        markers={markers}
        latitude={latitude}
        longitude={longitude}></EstablishmentInformation>
      <div id={'anchor4'}></div>
      <EstablishmentCommunity communities={establishment.relations.community} />
      <div id={'anchor5'}></div>
      <Container className={'container'}>
        <EstablishmentContact establishment={establishment} />
      </Container>
      {showMoveUpButton ? (
        <Box sx={{position: 'fixed', right: 0, top: '25%'}}>
          <IconButton
            className={'btn-gradient'}
            sx={{
              color: '#FFFFFF',
              borderRadius: 0,
              borderTopLeftRadius: '10%',
              borderBottomLeftRadius: '10%',
            }}
            onClick={moveUp}>
            <ArrowUpwardIcon
              role="img"
              aria-label={'Remonter au bloc précédent'}
            />
          </IconButton>
        </Box>
      ) : (
        <div></div>
      )}
      {showMoveDownButton ? (
        <Box sx={{position: 'fixed', right: 0, top: '32%'}}>
          <IconButton
            className={'btn-gradient'}
            sx={{
              color: '#FFFFFF',
              borderRadius: 0,
              borderTopLeftRadius: '10%',
              borderBottomLeftRadius: '10%',
            }}
            onClick={moveDown}>
            <ArrowDownwardIcon
              role="img"
              aria-label={'Descendre au prochain bloc'}
            />
          </IconButton>
        </Box>
      ) : (
        <div></div>
      )}
    </Box>
  );
};

export default Establishment;
